import { NavLink } from "react-router-dom";

const closeNavbar = () => {
  const navbar = document.getElementById("mainNavbar");
  if (navbar && navbar.classList.contains("show")) {
    navbar.classList.remove("show");
  }
};

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm">
      <div className="container">

        <NavLink className="navbar-brand fw-bold d-flex align-items-center" to="/">
          <img src="/images/img/Logo.jpeg" alt="Goodweel Logo" height="42" className="me-2" />
          <span>Goodweel</span>
        </NavLink>

        <button
          className="navbar-toggler custom-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div id="mainNavbar" className="collapse navbar-collapse">
          <ul className="navbar-nav ms-auto align-items-lg-center">

            <li className="nav-item">
              <NavLink className="nav-link" to="/" onClick={closeNavbar}>Home</NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/about" onClick={closeNavbar}>About Us</NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/products" onClick={closeNavbar}>Products</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/Productdetail" onClick={closeNavbar}>Product Details</NavLink>
            </li>

            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle category-link"
                role="button"
                data-bs-toggle="dropdown"
              >
                Category <span className="dropdown-arrow">▾</span>
              </span>

              <ul className="dropdown-menu shadow">
                <li><NavLink className="dropdown-item" onClick={closeNavbar} to="/products/insecticides">Insecticides</NavLink></li>
                <li><NavLink className="dropdown-item" onClick={closeNavbar} to="/products/fungicide">Fungicides</NavLink></li>
                <li><NavLink className="dropdown-item" onClick={closeNavbar} to="/products/herbicide">Herbicides</NavLink></li>
                <li><NavLink className="dropdown-item" onClick={closeNavbar} to="/products/fertilizer">Fertilizers</NavLink></li>
                <li><NavLink className="dropdown-item" onClick={closeNavbar} to="/products/pgr">Plant Growth Regulators</NavLink></li>
                <li><NavLink className="dropdown-item" onClick={closeNavbar} to="/products/npk">NPK Fertilizer</NavLink></li>
              </ul>
            </li>


            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={closeNavbar}>Contact</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
